import { type Observable } from 'rxjs'
import { type SystemNotification } from './'
import { type Notification } from './Notification'
import { map } from 'rxjs/operators'

/**
 * Maps a stream of notifications to a stream of system notifications.
 *
 * @param notification$
 * @param markAsRead
 * @param navigate
 */
export function notificationsToSystemNotifications(
  notification$: Observable<Notification>,
  markAsRead: (notification: Notification) => void,
  navigate: (url: string) => unknown,
): Observable<SystemNotification> {
  return notification$.pipe(
    map(
      (x): SystemNotification => ({
        title: x.workspace.name,
        body: x.plainText,
        tag: x.id || '',
        icon: x.imageUrl || undefined,
        onClick: () => {
          markAsRead(x)
          if (x.actionUrl) {
            navigate(x.actionUrl)
          }
        },
      }),
    ),
  )
}
